<template>
	<div class="statebar">
		<div class="statebar-line con-750">
			<div class="statebar-current" :style="`width: ${stateBarWidth}%`"></div>
		</div>
		<div class="statebar-name-position">
			<div class="statebar-name">
				<div v-for="(step, index) in steps" :key="index">
					<router-link
						v-if="!step.disabled && index <= getCurrentPage"
						:to="{ name: step.route, params: step.params }"
						:class="{ active: step.route === $route.name }"
					>
						{{ step.title }}
					</router-link>
					<span class="disabled" v-else>{{ step.title }}</span>
				</div>
			</div>
			<div class="statebar-name-mobile">
				<div v-for="(step, index) in computedForMobile" :key="index" class="mt-12px">
					<router-link
						v-if="!step.disabled && index <= mobileCurrent"
						:to="{ name: step.route, params: step.params }"
						:class="{ active: step.route === $route.name }"
					>
						{{ step.title }}
					</router-link>
					<span class="disabled" v-else>{{ step.title }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';

export default {
	props: {
		steps: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			mobileCurrent: 0,
		};
	},
	computed: {
		...mapGetters('contracting', ['getCurrentPage']),
		stateBarWidth() {
			const titleLength = this.steps.length;
			const titleIndex = _.findIndex(this.steps, step => step.title === this.$route.meta.title) + 1;
			return titleIndex === 1 ? 0 : (titleIndex / titleLength) * 100;
		},
		currentPage() {
			return _.findIndex(this.$router.options.routes[1].children, child => {
				return child.name === this.$route.name;
			});
		},
		computedForMobile() {
			let filtered = this.steps.filter(step => !step.disabled);

			if (this.currentPage === 0) {
				return filtered.slice(0, 2);
			}

			return filtered.slice(this.mobileCurrent - 1, this.mobileCurrent + 2);
		},
	},
	watch: {
		currentPage(newVal, oldVal) {
			this.mobileCurrent = newVal > oldVal ? this.mobileCurrent + 1 : this.mobileCurrent - 1;
		},
	},
};
</script>

<style lang="scss" scoped>
a {
	color: #000000;

	&:hover {
		text-decoration: underline;
	}
}

.active {
	color: #000000;
	font-weight: 700;
}

.disabled {
	color: #6a7178;
	pointer-events: none;
}
</style>
